import { render } from "./ProdutoPesoMedidas.vue?vue&type=template&id=77e9b31c&ts=true"
import script from "./ProdutoPesoMedidas.vue?vue&type=script&lang=ts"
export * from "./ProdutoPesoMedidas.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__